import { render, staticRenderFns } from "./VCMonthlyProdutionSummary.vue?vue&type=template&id=0474740a"
import script from "./VCMonthlyProdutionSummary.vue?vue&type=script&lang=js"
export * from "./VCMonthlyProdutionSummary.vue?vue&type=script&lang=js"
import style0 from "./VCMonthlyProdutionSummary.vue?vue&type=style&index=0&id=0474740a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports